<template>
    <TaxAddressItem
            v-for="(address, k) in addressList"
            :address="address"
            :key="k"
            @onSelectAddress="onSelectAddress(k)"
            @setDefaultTaxAddress="setDefaultTaxAddress(k)"
            @onDeleteAddress="onDeleteAddress($event)"
            @onEditAddress="onEditAddress($event)"
    ></TaxAddressItem>

    <!-- #region use with /taxaddress page -->
    <div v-if="isLoaded && !isHavItem && $route.path == '/taxaddress'" class="mt-24 lg:mt-12">
        <img class="mb-3 mx-auto w-10 lg:w-14" src="@/assets/icon/ic-tax-address.svg">
        <div class="mb-4 text-14 lg:text-16 text-center text-a-brown-9f8273">{{lbl.tax.tax_notfound}}</div>
    </div>
    <!-- #end region use with /taxaddress page -->
</template>
<script>
// mixins
import LocaleMixin from "@/mixin/LocaleMixin";
import ModalMixin from "@/mixin/ModalMixin";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
// components
import TaxAddressItem from "./TaxAddressItem.vue";
// service
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";

/**
 * @event onDeleteAddress
 * @event onEditAddress
 */
export default {
    name: "TaxAddressList",
    emits:['onEditAddress', 'onDeleteAddress'],
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    inject: ['PlaceOrderStore'],
    components: {
        TaxAddressItem,
    },
    data: function() {
        return {
            addressList: [],
            addressModel: null,
            isLoaded: false,
            isHavItem: false,
        };
    },
    mounted: function() {
        this.getAddressList();
    },
    methods: {
        getAddressList: function() {
            BzbsAddressList.apiGetTaxAddressList().subscribe((addressList) => {
                this.addressList = addressList;
                // #region use with /taxaddress page (set default tax checkbox)
                if(this.$route.path == '/taxaddress'){
                    for (let address of this.addressList){
                        if(address.isDefaultTax)
                            address.isSelect = true;
                    }
                }
                // #end region use with /taxaddress page (set default tax checkbox)
                this.isLoaded = true;
                this.isHavItem = this.addressList.length > 0;
            }, (err) => {
                this.isLoaded = true;
                this.errorApi(err);
            });
        },
        onSelectAddress: function(index) {
            let isSelect = this.addressList[index].isSelect;
            if (isSelect) {
                this.addressList[index].isSelect = false;
                this.PlaceOrderStore.state.placeOrder.taxAddressKey = null;
            } else {
                for (let address of this.addressList){
                    address.isSelect = false;
                }
                this.addressList[index].isSelect = true;
                this.PlaceOrderStore.state.placeOrder.taxAddressKey = this.addressList[index].rowKey;
            }
        },
        setDefaultTaxAddress:async function(index){
            let isSelect = this.addressList[index].isSelect;
            this.addressList[index].isTax = true;
            if (isSelect) {
                this.addressList[index].isSelect = false;
                this.addressList[index].isDefaultTax = false
            } else {
                for (let address of this.addressList){
                    address.isSelect = false;
                }
                this.addressList[index].isSelect = true;
                this.addressList[index].isDefaultTax = true
            }
            let params = this.addressList[index].getParams();
            await this.apiSetDefaultTaxAddress(params);
        },
        apiSetDefaultTaxAddress: function(params){
            this.modal.loadingModal.show();
            return new Promise((resolve) => {
                BzbsAddressList.apiSaveTaxAddress(params).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.getAddressList();
                        this.modal.loadingModal.hide();
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.modal.loadingModal.hide();
                        this.errorApi(err);
                    },
                });
            });
        },
        getData: function() {
            for (let address of this.addressList){
                if (address.isSelect) {
                    return address;
                }
            }
            return null;
        },
        onDeleteAddress: function(address) {
            this.$emit('onDeleteAddress', address);
        },
        onEditAddress: function(address) {
            this.$emit('onEditAddress', address);
        },
    },
}
</script>
